<template>
  <div>
    <v-select
      ref="vSelect"
      v-model="valueLocal"
      class="w-full"
      :options="statusOptions"
      :multiple="false"
      :clearable="false"
      close-on-select
      :getOptionLabel="getOptionLabel"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select';
import enums from '@/enums';

// Mixins
import filterMixin from '@/views/modules/segment/create-or-edit/_mixins/filter.mixin';

/**
 * boolean filter for create or edit segment
 *
 * @module views/modules/segment/create-or-edit/SegmentListCreateOrEditStatusFilter
 * @author Dilan Useche <dilan8810@gmail.com>
 */
export default {
  name: 'SegmentListCreateOrEditStatusFilter',
  components: {
    vSelect,
  },
  mixins: [filterMixin],
  props: {
    value: {
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    getOptionLabel: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
